import menu from './service';
import userService from './userService';

export default {
    menu,userService
};